import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sizingRangesGetRequest = simpleAction(TYPES.SIZING_RANGES_GET_REQUEST);

/**
 * Request sizingRanges success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sizingRangesGetSuccess = simpleAction(TYPES.SIZING_RANGES_GET_SUCCESS);

/**
 * Request sizingRanges error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const sizingRangesGetError = simpleAction(TYPES.SIZING_RANGES_GET_FAIL);
